import React from 'react';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';

import {
  overlayInnerStyle,
  overlayStyle,
  rcTooltipClass,
} from './TooltipWrapper.constants';

import styles from './TooltipWrapper.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '../Text';

export const TooltipWrapperComponent = ({
  children,
  tooltip = null,
  wrapperClassName = '',
  tooltipType = null,
  tooltipPlacement = 'top',
  mouseEnterDelay = 0,
  mouseLeaveDelay = 0,
}) => {
  const tooltipLogic = tooltip ? {} : { visible: false };
  const wrapperClass = classNames(styles.tooltipWrapper, wrapperClassName);
  let overlay = null;
  if (typeof tooltip === 'string') {
    overlay = (
      <div>
        <Text
          variant={textVariantsEnum.Text_xs}
          fontWeight={fontWeightEnum.Normal}
          color="gray-600"
        >
          {tooltip}
        </Text>
      </div>
    );
  } else {
    overlay = tooltip;
  }

  return (
    <Tooltip
      // overlayInnerStyle={overlayInnerStyle}
      overlayStyle={overlayStyle}
      placement={tooltipPlacement}
      mouseEnterDelay={mouseEnterDelay}
      mouseLeaveDelay={mouseLeaveDelay}
      trigger={'hover'}
      overlayClassName={rcTooltipClass.tooltipOverlayClass}
      overlay={tooltip}
      {...tooltipLogic}
    >
      <div className={wrapperClass}>{children}</div>
    </Tooltip>
  );
};
